import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PageText } from './page-text';

@NgModule({
  declarations: [
    PageText,
  ],
  imports: [
    IonicPageModule.forChild(PageText),
  ],
  exports: [
    PageText
  ]
})
export class PageTextModule {}



// WEBPACK FOOTER //
// ./src/pages/page-text/page-text.module.ts